import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

export const LabelAndTooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const Label = styled.span`
  display: flex;
  height: 100%;
  align-items: center;
  margin-left: ${(props) => props.theme.mp.sm};
  font-weight: ${(props) => props.theme.font.weights.light};
`
